export default __webpack_public_path__ + "c44a71af12fb8aa7d9abee485a3ced04.glb";